<template>
  <div class="index">
    <div class="index-con">
      <div class="big-title">
        <span>{{ $t("travelbigtitle") }}</span>
      </div>

      <div class="text">
        {{ $t("traveltext1") }}
      </div>
      <div class="text">
        <b> {{ $t("traveltext2") }}</b> {{ $t("traveltext3") }}
      </div>
      <div class="text">
        <b> {{ $t("traveltext4") }}</b>
        <a href="https://www.worldhotelgrandjuna.com/" target="_blank" class="email">
          https://www.worldhotelgrandjuna.com/
        </a>
      </div>
      <img class="img" src="http://mk.chinaman.cn/mybigdatas/ids/static/hotel.jpeg" alt="" />

      <div class="two-con">
        <div class="two-left-img">
          <img class="left-img" src="@/assets/img-14.png" alt="" />
        </div>
        <div class="two-right">
          <div class="left-title">Arriving By Air</div>
          <div class="two-text text-1">
            Worldhotel Grand Juna Wuxi is approximately 170 km from Shanghai
            Pudong Airport (PVG)
          </div>
          <div class="two-text text-1">
            Worldhotel Grand Juna Wuxi is approximately 120 km from Shanghai
            Hongqiao International Airport (SHA)
          </div>
          <div class="two-text text-1">
            Worldhotel Grand Juna Wuxi is approximately 12 km from Wuxi Sunan
            Shuofang International Airport (WUX)
          </div>
        </div>
      </div>

      <div class="two-con">
        <div class="two-left-img">
          <img class="left-img" src="@/assets/img-15.png" alt="" />
        </div>
        <div class="two-right">
          <div class="left-title">Railways</div>
          <div class="two-text text-1">
            Wuxi is situated at the intersection of two railways:
            Shanghai-Beijing Railway. Shanghai-Beijing Railway goes through Wuxi
            New District from west to east. Worldhotel Grand Juna is located in
            Wuxi New District.
          </div>
          <div class="two-text text-1">
            The Shanghai-Nanjing Intercity Express Railway directly links Wuxi
            to China's economic hub, Shanghai (30-45 minutes train-ride), the
            provincial capital of Nanjing (1.5 hours train-ride) and the fifth
            biggest economic hub and tourist destination Suzhou (24 minutes
            train-ride). One Station is located in Wuxi New District, where the
            Worldhotel Grand Juna is situated.
          </div>
          <div class="two-text text-1">
            Wuxi Railway Station (无锡站)，Wuxi East Railway Station (无锡东站)
            and Wuxi New District Station (无锡新区站) are all recommended train
            stations to reach Wuxi by train.
          </div>
        </div>
      </div>
      <div class="two-con">
        <div class="two-left-img">
          <img class="left-img" src="@/assets/img-16.png" alt="" />
        </div>
        <div class="two-right">
          <div class="left-title">Ground Transportation</div>
          <div class="two-text">
            We recommend taking a taxi to Worldhotel Grand Juna Wuxi
            (无锡君来世尊酒店).
          </div>
          <div class="two-text text-1">
            15 km from Wuxi Railway Station (无锡站), about 25 minutes by taxi
          </div>
          <div class="two-text text-1">
            22 km from Wuxi East Railway Station (无锡东站) , about 40 minutes
            by taxi
          </div>
          <div class="two-text text-1">
            15 km from Wuxi Sunan Shuofang Airport (无锡苏南硕放机场), about 30
            minutes by taxi
          </div>
        </div>
      </div>
      <div class="title">Driving Directions on Google Maps：</div>
      <iframe v-if="$t('travelText6') == 'en'"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9686.475195985919!2d120.31601149071314!3d31.47841453112593!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35b385201cf2d979%3A0x7edb48baa0649d06!2z5Lit5Zu95rGf6IuP55yB5peg6ZSh5biC5ruo5rmW5Yy65rKz5Z-S5Y-j5peg6ZSh5ZCb5p2l5LiW5bCK6YWS5bqXIOmCruaUv-e8lueggTogMjE0MTMy!5e0!3m2!1szh-CN!2sus!4v1701435358974!5m2!1szh-CN!2sus"
        width="100%" height="550" style="border: 0" allowfullscreen="" loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"></iframe>
      <iframe v-else src="https://j.map.baidu.com/7c/mW2K" width="100%" height="550" style="border: 0"
        allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: "",
    };
  },
  mounted() {
    this.url = this.$t("travelText5");
    console.log(this.url);
  },
  methods: {},
};
</script>

<style scoped>
.two-con {
  display: flex;
  margin-bottom: 50px;
}

.two-left-img {
  width: 35%;
}

.left-img {
  width: 100%;
  height: auto;
}

.two-right {
  flex: 1;
  padding-left: 30px;
  position: relative;
}

.text-1 {
  text-indent: 0;
  padding-left: 2em;
  position: relative;
}

.text-1::after {
  content: "";
  left: 0;
  top: 8px;
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #333;
}

.two-text {
  box-sizing: border-box;
  color: #333;
  font-size: 14px;
  line-height: 1.8;
  padding-bottom: 20px;
}

.left-title {
  font-weight: 600;
  font-size: 20px;
  display: flex;
  margin-bottom: 20px;
  align-items: center;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
}

.img {
  width: 80%;
  display: block;
  margin: 0 auto;
  height: auto;
  margin-bottom: 30px;
}

.email {
  cursor: pointer;
  color: rgb(30, 98, 222);
  font-weight: 600;
}

.title {
  color: #0a9a7a;
  font-size: 24px;
  text-align: left;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 70px;
  margin-top: 50px;
  position: relative;
}

/* .title::after {
  content: "";
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  width: 160px;
  height: 4px;
  text-align: center;
  background: #0a9a7a;
  position: absolute;
  margin-bottom: -10px;
} */

.index-con {
  margin: 0 auto;
  width: 1200px;
  padding-bottom: 170px;
}

.text {
  padding-left: 300px;
  box-sizing: border-box;
  color: #333;
  text-indent: 2em;
  font-size: 16px;
  line-height: 2;
  padding-bottom: 20px;
}

.w-350 {
  width: 350px;
  margin: 0 auto;
  text-indent: 0;
  text-align: center;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .nav {
    width: 100%;
  }

  .title {
    font-size: 18px;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }

  .text {
    padding-left: 10px;
  }

  .two-con {
    display: block;
    padding: 10px;
    box-sizing: border-box;
  }

  .two-left-img {
    width: 100%;
  }

  .two-right {
    padding: 0;
    margin-top: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/travel.vue